<script>

    import { fade } from 'svelte/transition'
    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'
    import { modalStore } from '../stores'
    
    import LocationsService from '../$services/locations.service'

    import Spinner from '../$components/spinner.svelte'
    import Switch from '../$components/switch.svelte'
    import Button from '../$components/button.svelte'
    import ModalId from '../$components/modal.id.svelte'

    import ZipcodeColonyComponent from './component.zipcode.colony.svelte'
    import LocationCreateExpressComponent from './component.create.express.svelte'
    import ZipcodesComponent from './component.zipcodes.svelte'

    const dispatch = createEventDispatcher()

    export let step = null
    export let location = {}

    export let showSwitchs = true
    export let showSelected = true
    export let showButtons = true
    export let disabled = false

    let loading = false

    function onSelected() {
        dispatch('selected', location)
    }

    if(showSelected && !location.zipcode)
        getLocationDefault()

    async function getLocationDefault() {

        loading = true
        const resp = await LocationsService.getLocationDefault()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(resp.data)
            location = resp.data
    }

</script>

<Spinner {loading} />

{#if !loading}
    {#if showSelected}
        <label for="" class="label">Buscar dirección</label>
        <ZipcodesComponent bind:selected={ location } required={false} />
        <hr>
    {/if}
    <form on:submit|preventDefault={onSelected} in:fade>
        {#if location}
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Contacto</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-user"></i></span>
                            <input bind:value={location.contact} type="text" class="input" placeholder="Contacto" required style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label for="" class="label">RFC</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-building"></i></span>
                            <input bind:value={location.rfc} type="text" class="input" placeholder="RFC con homoclave" minlength="12" maxlength="13">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Corporación</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-building"></i></span>
                            <input bind:value={location.corporate} type="text" class="input" placeholder="Corporación" style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Teléfono</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-phone"></i></span>
                            <input bind:value={location.phone} type="text" class="input" placeholder="Teléfono" required style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Correo electrónico</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-envelope"></i></span>
                            <input bind:value={location.email} type="email" class="input" placeholder="Correo electrónico" required style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
            </div>
            <ZipcodeColonyComponent
                bind:zipcode={location.zipcode}
                bind:state={location.state}
                bind:city={location.city}
                bind:municipality={location.municipality}
                bind:colony={location.colony}
                {disabled}
                {step}
            />
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Calle</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                            <input bind:value={location.street} type="text" class="input" placeholder="Calle" required style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Número exterior</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-hashtag"></i></span>
                            <input bind:value={location.number} type="text" class="input" placeholder="Exterior" style="text-transform:uppercase;" required>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label for="" class="label">Número interior</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-hashtag"></i></span>
                            <input bind:value={location.apartment} type="text" class="input" placeholder="Interior" style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
                <div class="column is-6">
                    <div class="field">
                        <label for="" class="label">Referencias</label>
                        <div class="control has-icons-left">
                            <span class="icon"><i class="fas fa-asterisk"></i></span>
                            <input bind:value={location.references} type="text" class="input" placeholder="Referencias" style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
            </div>
            {#if showSwitchs}
                {#if step === 'pickup' }
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <Switch bind:checked={location.sendEmail} label="Envíar correo a remitente" />
                            </div>
                        </div>
                    </div>
                {:else}
                    <div class="columns">
                        <div class="column">
                            <div class="field">
                                <Switch bind:checked={location.sendEmail} label="Envíar correo a destinatario" />
                            </div>
                        </div>
                    </div>
                {/if}
            {/if}
        {/if}
        {#if showButtons}
            <div class="items-end">
                <div class="buttons">
                    <Button on:click={() => modalStore.set('LocationCreateExpress')} type="button" text="Guardar dirección" icon="save" />
                    <Button type="submit" text="Continuar" icon="arrow-circle-right" color="primary" />
                </div>
            </div>
        {/if}
    </form>
{/if}

<ModalId id="LocationCreateExpress" title="Guardar dirección">
    <LocationCreateExpressComponent data={ location } />
</ModalId>